import React, { useState } from 'react';
import { X, Gift } from 'lucide-react';

const Inventory = ({ gifts, onPlaceGift, onClose }) => {
  const [selectedSort, setSelectedSort] = useState('price-asc');

  const getSortedGifts = () => {
    const sorted = [...gifts];
    
    if (selectedSort === 'price-asc') {
      return sorted.sort((a, b) => a.price - b.price);
    } else if (selectedSort === 'price-desc') {
      return sorted.sort((a, b) => b.price - a.price);
    }
    
    return sorted;
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-end z-50"
      onClick={onClose}
    >
      <div 
        className="bg-gradient-to-b from-blue-800 to-purple-800 rounded-t-3xl w-full max-h-[80vh] overflow-y-auto p-6"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">Ваши подарки</h3>
          <button 
            onClick={onClose}
            className="hover:bg-white/10 p-2 rounded-full transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="mb-4">
          <select 
            value={selectedSort}
            onChange={(e) => setSelectedSort(e.target.value)}
            className="bg-blue-700 px-4 py-2 rounded-lg w-full text-white outline-none"
          >
            <option value="price-asc">Цена: по возрастанию</option>
            <option value="price-desc">Цена: по убыванию</option>
          </select>
        </div>

        {gifts.length === 0 ? (
          <div className="text-center py-8 text-gray-300">
            <Gift className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p>У вас нет подарков</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {getSortedGifts().map(gift => (
              <button
                key={gift.id}
                onClick={() => {
                  onPlaceGift(gift.id);
                  onClose();
                }}
                className="bg-blue-700/50 backdrop-blur-sm p-4 rounded-xl hover:bg-blue-600/50 transition-all hover:scale-105"
              >
                <div className="text-4xl mb-2">{gift.icon}</div>
                <div className="text-sm font-medium mb-1 truncate">{gift.name}</div>
                <div className="flex items-center justify-center gap-1 text-yellow-400">
                  <Gift className="w-4 h-4" />
                  <span className="font-bold">{gift.price.toFixed(2)}</span>
                </div>
                <div className="text-xs text-gray-300">({gift.price.toFixed(2)} TON)</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Inventory;